module.exports = __webpack_public_path__ + "media/img/event/S2U_MastHead_EDM-1f6daccddb596fb21b9d9b4e74c6d29e.png";